module.exports = __webpack_public_path__ + "static/img/avatar.fbef168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar.png
// module id = zQrT
// module chunks = 1